import { onError, ErrorResponse } from '@apollo/client/link/error';

// Console log graphql error
// eslint-disable-next-line @typescript-eslint/naming-convention
export const errorLink = onError(({ graphQLErrors }: ErrorResponse): void => {
  if (graphQLErrors) {
    // eslint-disable-next-line no-console
    graphQLErrors.map(({ message }) => console.error('Graphql Error:', message));
  }
});
